import { render, staticRenderFns } from "./FollowStatecsOn.vue?vue&type=template&id=4f79443b&"
import script from "./FollowStatecsOn.vue?vue&type=script&lang=js&"
export * from "./FollowStatecsOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports